import './WinnerOffer.css';
import {useActions} from "../../../../hooks/useActions";


function WinnerOffer() {
    const {setRoute} = useActions();


    return (
        <div className='wiContiner' onClick={() => setRoute('home')}>
            <div className='wiBannerContainer'>

                <div className='wiCloseButton' onClick={() => {
                    setRoute('home');
                }}></div>

                <div
                    className='wiButton defaultButtonAnimation_5'
                    onClick={() => {
                        window.open("https://www.patreon.com/c/depravedworld", "_blank");
                    }}
                >
                </div>

            </div>
        </div>
    );
}

export default WinnerOffer;